'use client';

import { createContext, useContext } from 'react';

// React context survives Radix portals, so a picker opened inside a dialog
// always appears above it. Keep the layers below the app's toast layer.
export const OverlaySurfaceDepth = createContext(0);
const layers = [
  'z-50',
  'z-[51]',
  'z-[52]',
  'z-[53]',
  'z-[54]',
  'z-[55]',
  'z-[56]',
  'z-[57]',
  'z-[58]',
  'z-[59]',
];

export const floatingSurface =
  'bg-popover text-popover-foreground border border-border shadow-[0_8px_24px_color-mix(in_srgb,var(--foreground)_12%,transparent),0_2px_6px_color-mix(in_srgb,var(--foreground)_6%,transparent)]';

export function useOverlaySurface() {
  const depth = useContext(OverlaySurfaceDepth);
  return { depth, layer: layers[Math.min(depth, layers.length - 1)] };
}
